import React, { useContext } from 'react';

import { Redirect, Route, RouteComponentProps, RouteProps, useHistory } from 'react-router-dom';

import LoadingSpinner from '@/components/LoadingSpinner';
import { User } from '@/core/api/collections/currentAccount';
import { AuthContext } from '@/core/auth/AuthContext';
import { POST_LOGIN_REDIRECT_QUERY_PARAM } from '@/core/coreConstants';
import routes from '@/routes';

type Props = RouteProps & {
  accessDeniedPath: string;
  ignoreLogout?: boolean;
}

export function PrivateRoute({ accessDeniedPath, children, component: Component, ...rest }: Props) {
  const { location } = useHistory();
  const { currentUser, loading } = useContext(AuthContext);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!currentUser || !allowUserAccess(currentUser)) {
    // Grab the path the user is trying to access in case we need to redirect them back after login.
    const currentPathEncoded = encodeURIComponent((location.pathname + location.search) || '/');
    return (
      <Redirect
        to={{
          pathname: !currentUser ? accessDeniedPath : routes.empty,
          search: `?${POST_LOGIN_REDIRECT_QUERY_PARAM}=${currentPathEncoded}`,
        }}
      />
    );
  }

  const ProtectedView = (props: RouteComponentProps) => {
    return Component ? <Component {...props} /> : children;
  };

  return <Route {...rest} render={ProtectedView} />;
}

function allowUserAccess(user: User) {
  return user.coreAllowsSettings || user.uvkAdmin;
}
